// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#table-provider td[data-v-37c61300],#table-provider th[data-v-37c61300]{padding:7px 16px}#table-provider tr[data-v-37c61300]{border-bottom:1px solid rgba(0,0,0,.12)}#table-provider th[data-v-37c61300]{font-size:medium;border-top:1px solid #c6c6c6}", ""]);
// Exports
module.exports = exports;
